var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heating-system-warning-2"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"label"},[_vm._v("总次数")])])])}
var staticRenderFns = []

export { render, staticRenderFns }